/**
 * URL patterns where the heartbeat banner should NOT be displayed.
 * The heartbeat service continues to run, only the UI is hidden.
 */

/** Substring patterns matched with url.includes() */
export const EXCLUDED_URL_SUBSTRINGS: string[] = [
	'/jira/settings',
	'/auditing/',
	'/secure/project',
	'/secure/admin',
];

/** Regex patterns matched with regex.test() */
export const EXCLUDED_URL_REGEXES: RegExp[] = [
	/^https:\/\/pollinator-rovo-for-service-stg\.jira-dev\.com/,
];
